var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5C4.41015 14.5 1.5 11.5899 1.5 8H-1.5C-1.5 13.2467 2.75329 17.5 8 17.5V14.5ZM14.5 8C14.5 11.5899 11.5899 14.5 8 14.5V17.5C13.2467 17.5 17.5 13.2467 17.5 8H14.5ZM8 1.5C11.5899 1.5 14.5 4.41015 14.5 8H17.5C17.5 2.75329 13.2467 -1.5 8 -1.5V1.5ZM8 -1.5C2.75329 -1.5 -1.5 2.75329 -1.5 8H1.5C1.5 4.41015 4.41015 1.5 8 1.5V-1.5Z",
    fill: "#DCDEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcoming);
export default __webpack_public_path__ + "static/media/upcoming.a79e200457c87a3ca9aa81b162ce53cc.svg";
export { ForwardRef as ReactComponent };